(() => {
  const formatMoney = (cents) =>
    `$${(Number(cents) / 100).toFixed(2)}`;

  const initializePackCards = (grid) => {
    if (grid.dataset.frPackCardsReady === 'true') return true;

    const variantPicker = document.querySelector(
      'variant-radios, variant-selects'
    );

    const productJson = variantPicker?.querySelector(
      'script[type="application/json"]'
    );

    if (!variantPicker || !productJson) return false;

    let variants;

    try {
      variants = JSON.parse(productJson.textContent);
    } catch (error) {
      console.error(
        'Folk Revival: Could not read product variant data.',
        error
      );
      return false;
    }

    const cards = [...grid.querySelectorAll('.fr-pack-card')];
    const isPouch = grid.dataset.productKind === 'pouch';

    const getVariant = (card) =>
      variants.find(
        (variant) => variant.title === card.dataset.pack
      ) || variants[Number(card.dataset.frPackIndex)];

    const getNativeInput = (card) =>
      [...variantPicker.querySelectorAll('input[type="radio"]')]
        .find((input) => input.value === card.dataset.pack);

    const getSelectedPlanId = () => {
      const selectedPlan = document.querySelector(
        '#appstle_subscription_widget0 input[name="selling_plan"]:checked'
      );

      if (!selectedPlan?.value) return null;

      // the frequency dropdown updates before Appstle moves the radio, so trust it when subscribing
      const frequency = document.querySelector('#appstle_subscription_widget0 select.appstle_select');
      return Number(frequency?.value || selectedPlan.value);
    };

    const planSelectedForSix = () => Boolean(getSelectedPlanId());
    const getPrice = (variant) => {
      const planId = getSelectedPlanId();

      if (!planId) return Number(variant.price);

      const allocation = (
        variant.selling_plan_allocations || []
      ).find(
        (item) => Number(item.selling_plan_id) === planId
      );

      return allocation
        ? Number(allocation.price)
        : Number(variant.price);
    };

    const KIT_PLAN_ID = 7852523771;
    const KIT_TICK =
      '<strong>Your Starter Kit:</strong> 12 cups now, then 24 every 2 months for $107.10.';

    // first check mark in the orange box; idempotent so the widget observer settles
    // Nov 3 2026: Appstle's own ticks, one line each on phones (the texts are set in Appstle; this trims them)
    const TICK_MAP = {
      'Free Maple Walnut Pouch (10 servings) in your first box': 'Free Maple Walnut pouch in your first box',
      '10% off every box': '10% off and free shipping on every box',
      'Free shipping on every box': '',
      'Skip, swap, pause, or cancel anytime': 'Skip, swap, pause or cancel anytime',
      'Free Recipe E-Book with your first box': 'Free recipe e-book with your first box'
    };
    const trimTicks = (list) => {
      [...list.querySelectorAll('li:not(.fr-kit-tick)')].forEach((li) => {
        const key = li.textContent.trim();
        if (!(key in TICK_MAP)) return;
        if (TICK_MAP[key] === '') li.remove();
        else li.textContent = TICK_MAP[key];
      });
    };
    const updateKitTick = (show) => {
      const list = document.querySelector(
        '#appstle_subscription_widget0 .appstleSelectedSellingPlanOptionDescription ul'
      );
      if (!list) return;
      trimTicks(list);
      const existing = list.querySelector('li.fr-kit-tick');
      if (show && !existing) {
        const model = list.querySelector('li');
        const li = model ? model.cloneNode(false) : document.createElement('li');
        li.classList.add('fr-kit-tick');
        li.innerHTML = KIT_TICK;
        list.insertBefore(li, list.firstChild);
      } else if (!show && existing) {
        existing.remove();
      }
    };

    const updateCards = () => {
      const firstCard = cards.find((c) => !(c.dataset.pack === '6 Pack' && !isPouch)) || cards[0];
      const firstVariant = firstCard
        ? getVariant(firstCard)
        : null;

      if (!firstCard || !firstVariant) return;

      const firstUnits =
        Number(firstCard.dataset.unitCount) || 1;

      const firstUnitPrice =
        getPrice(firstVariant) / firstUnits;

      cards.forEach((card, index) => {
        const variant = getVariant(card);
        if (!variant) return;

        const units = Number(card.dataset.unitCount) || 1;
        const price = getPrice(variant);
        const unitPrice = price / units;

        const priceElement =
          card.querySelector('.fr-pack-price');

        const unitElement =
          card.querySelector('.fr-pack-unit');

        const savingElement =
          card.querySelector('.fr-pack-saving');

        if (priceElement) {
          priceElement.textContent = formatMoney(price);
        }

        if (unitElement) {
          unitElement.textContent = isPouch
            ? `${formatMoney(Math.round(unitPrice))} per serving`
            : `${formatMoney(Math.round(unitPrice))} per cup`;
        }

        const isSix = card.dataset.pack === '6 Pack' && !isPouch;
        if (savingElement && isSix) {
          savingElement.textContent = planSelectedForSix() ? '\u00A0' : 'Buy once';
          savingElement.classList.remove('fr-pack-saving--gift');
          savingElement.classList.toggle('fr-pack-saving--empty', !!planSelectedForSix());
        } else if (savingElement) {
          const comparablePrice = firstUnitPrice * units;
          const savings = card !== firstCard ? Math.max(0, Math.round(comparablePrice - price)) : 0;
          const savingsPercent = comparablePrice > 0
            ? Math.round((savings / comparablePrice) * 100)
            : 0;
          const planSelected = Boolean(getSelectedPlanId());
          const savingText = savings > 0
            ? (planSelected ? `Save ${formatMoney(savings)}` : `Save ${formatMoney(savings)} (${savingsPercent}%)`)
            : '';
          const giftFrom = Number(grid.dataset.giftFrom || 1);
          const giftFirst = grid.dataset.giftFirst || '';
          const giftMore = grid.dataset.giftMore || '';
          let text = savingText;
          let gift = false;
          const giftPos = cards.slice(0, index + 1).filter((c) => !(c.dataset.pack === '6 Pack' && !isPouch)).length;
          if (planSelected && giftPos >= giftFrom) {
            gift = true;
            // Starter Kit wording only where the swap runs: cups, 12 Pack, the 2-month plan
            const kitWording = isPouch || getSelectedPlanId() === KIT_PLAN_ID;
            text = giftPos === giftFrom
              ? (kitWording ? giftFirst : giftMore)
              : (savingText ? `${savingText} ${giftMore}` : giftMore);
          }
          savingElement.textContent = text || '\u00A0';
          savingElement.classList.toggle('fr-pack-saving--gift', gift);
          savingElement.classList.toggle('fr-pack-saving--empty', !text);
        }

        const nativeInput = getNativeInput(card);
        const selected = Boolean(nativeInput?.checked);

        if (!isPouch && card.dataset.pack === '12 Pack') {
          updateKitTick(selected && getSelectedPlanId() === KIT_PLAN_ID);
        }

        // Nov 3 2026: per-cup line under the subscription price in the orange box, for the selected card
        if (selected) {
          const amountWrapper = document.querySelector(
            '#appstle_subscription_widget0 .appstle-active-option .appstle_subscription_amount_wrapper'
          );
          const perCupText = isPouch
            ? `${formatMoney(Math.round(unitPrice))} a serving`
            : `${formatMoney(Math.round(unitPrice))} a cup`;
          document.querySelectorAll('#appstle_subscription_widget0 .fr-per-cup').forEach((el) => {
            if (el.parentElement !== amountWrapper) el.remove();
          });
          if (amountWrapper && getSelectedPlanId()) {
            let perCup = amountWrapper.querySelector('.fr-per-cup');
            if (!perCup) {
              perCup = document.createElement('div');
              perCup.className = 'fr-per-cup';
              amountWrapper.appendChild(perCup);
            }
            if (perCup.textContent !== perCupText) perCup.textContent = perCupText;
          }
        }

        card.classList.toggle('is-selected', selected);
        card.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const nativeInput = getNativeInput(card);
        if (!nativeInput) return;

        nativeInput.checked = true;
        nativeInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        window.setTimeout(updateCards, 150);
      });
    });

    // run once Appstle has finished redrawing, not on its first mutation
    let updateTimer = null;
    const scheduleUpdate = () => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(updateCards, 200);
    };

    document.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'variant-radios input[type="radio"], ' +
          '#appstle_subscription_widget0 input[name="selling_plan"], ' +
          '#appstle_subscription_widget0 select.appstle_select'
        )
      ) {
        scheduleUpdate();
      }
    });

    const appstleWidget = document.querySelector(
      '#appstle_subscription_widget0'
    );

    if (appstleWidget) {
      const observer = new MutationObserver(scheduleUpdate);

      observer.observe(appstleWidget, {
        subtree: true,
        childList: true,
        attributes: true
      });
    }

    grid.dataset.frPackCardsReady = 'true';
    (() => {
      const u = new URL(window.location.href);
      const offerSix = u.searchParams.get('offer') === 'six';
      grid.querySelectorAll('.fr-pack-card--six').forEach((c) => { if (offerSix) { c.classList.remove('fr-pack-card--six'); grid.classList.add('fr-has-six'); } });
    })();
    variantPicker.classList.add('fr-native-variant-picker--hidden');
    updateCards();
    const appstlePricingTimer = window.setInterval(() => {
  if (document.querySelector('#appstle_subscription_widget0')) {
    updateCards();
    window.clearInterval(appstlePricingTimer);
  }
}, 250);

window.setTimeout(() => {
  window.clearInterval(appstlePricingTimer);
}, 15000);

    return true;
  };
  const getSelectedPack = () => {
    const checkedInputs = [
      ...document.querySelectorAll(
        'variant-radios input[type="radio"]:checked'
      )
    ];

    const packInput = checkedInputs.find((input) =>
      /^(6|12|24|48)\s*Pack$/i.test(input.value.trim())
    );

    return packInput?.value || null;
  };

  const getSelectedSellingPlan = () =>
    document.querySelector('input[name="selling_plan"]:checked')?.value || null;

  const initializeFlavorNavigation = () => {
    if (
      document.documentElement.dataset.frFlavorNavigationReady === 'true'
    ) {
      return;
    }

    document.documentElement.dataset.frFlavorNavigationReady = 'true';

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest(
        '.product_page_flavour a[href]'
      );

      if (!link) return;

      const linkLabel = link.textContent.trim().toLowerCase();

      // Leave the Maple Cup/Pouch package selector alone.
      if (linkLabel === 'cup' || linkLabel === 'pouch') return;

      const selectedPack = getSelectedPack() || '12 Pack';
      const destinationUrl = new URL(
        link.href,
        window.location.origin
      );

      event.preventDefault();

      try {
        const response = await fetch(
          `${destinationUrl.pathname}.js`
        );

        if (!response.ok) {
          throw new Error(
            `Product request failed: ${response.status}`
          );
        }

        const destinationProduct = await response.json();

        const possibleVariants =
          destinationProduct.variants.filter((variant) => {
            const options = variant.options || [];

            return (
              variant.title === selectedPack ||
              options.includes(selectedPack)
            );
          });

        const matchingVariant =
          possibleVariants.find((variant) =>
            (variant.options || []).includes('Cup')
          ) || possibleVariants[0];

        if (matchingVariant) {
          destinationUrl.searchParams.set(
            'variant',
            matchingVariant.id
          );
        }

        const sellingPlan = getSelectedSellingPlan();

        if (sellingPlan) {
          destinationUrl.searchParams.set(
            'selling_plan',
            sellingPlan
          );
        }

        destinationUrl.searchParams.delete('view');

        window.location.href = destinationUrl.toString();
      } catch (error) {
        console.error(
          'Folk Revival: could not preserve pack size.',
          error
        );

        window.location.href = link.href;
      }
    });
  };
  const updateActiveFlavorLinks = () => {
    const currentPath = window.location.pathname.replace(/\/$/, '');

    document
      .querySelectorAll('.product_page_flavour li')
      .forEach((item) => {
        const link = item.querySelector('a[href]');

        if (!link) return;

        const linkPath = new URL(
          link.href,
          window.location.origin
        ).pathname.replace(/\/$/, '');

        const isActive = linkPath === currentPath;

        item.classList.toggle('active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
  };

  updateActiveFlavorLinks();
  initializeFlavorNavigation();
  const start = () => {
    const grids = [
      ...document.querySelectorAll('[data-fr-pack-cards]')
    ];

    if (!grids.length) return false;

    return grids.every(initializePackCards);
  };

  if (!start()) {
    const initializationTimer = window.setInterval(() => {
      if (start()) {
        window.clearInterval(initializationTimer);
      }
    }, 250);

    window.setTimeout(() => {
      window.clearInterval(initializationTimer);
    }, 15000);
  }
})();